export default __webpack_public_path__ + "static/media/nufferton.4e6132cb.png";